export default __webpack_public_path__ + "static/media/requirements-embedded.a4990761.jpg";